import React from 'react';
import DatePicker from 'react-datepicker';
import styles from './style.module.scss';

interface DatePickerProps {
  currDate: Date;
  selectedDate: Date;
  maxDate: Date;
  modalClose: () => void;
  setStartDate: (date: Date) => void;
}

const DatePickerComp = (props: DatePickerProps) => {
  const { selectedDate, currDate, setStartDate, maxDate } = props;
  const changeDate = (date: Date) => {
    setStartDate(date);
  };
  return (
    <DatePicker
      selected={selectedDate}
      minDate={currDate}
      maxDate={maxDate}
      useWeekdaysShort={true}
      calendarClassName={`${styles.calendarContainer}`}
      onChange={changeDate}
      inline
    />
  );
};

export default DatePickerComp;
